import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import { card, inputCls } from './LegalConfigEditor';
import ConsentProofButton from '../compliance/ConsentProofButton';
import { useToast } from '../../hooks/use-toast';

const ACTIONS = ['', 'opt_in', 'declined', 'stop', 'start', 'help', 'host_authorization'];

export default function ConsentLog() {
  const { toast } = useToast();
  const [rows, setRows] = useState([]);
  const [phone, setPhone] = useState('');
  const [action, setAction] = useState('');
  useEffect(() => {
    const t = setTimeout(() => {
      client.get('/admin/compliance/consents', { params: { phone: phone || undefined, action: action || undefined } })
        .then(({ data }) => setRows(data.consents)).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [phone, action]);

  return (
    <section data-testid="consent-log" className={card + ' space-y-3'}>
      <div>
        <h3 className="font-serif text-xl text-[#2A2A2A]">Consent audit log</h3>
        <p className="text-xs text-[#6A6A6A]">Append-only. Every opt-in, decline, STOP, START, HELP and host authorization with wording version, IP and time.</p>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <input data-testid="consent-search-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Search phone" className={inputCls} />
        <select data-testid="consent-filter-action" value={action} onChange={(e) => setAction(e.target.value)} className={inputCls}>
          {ACTIONS.map((a) => <option key={a} value={a}>{a ? a.replace('_', ' ') : 'All actions'}</option>)}
        </select>
      </div>
      <ul className="text-xs divide-y divide-[#F2E8DE] max-h-72 overflow-auto">
        {rows.length === 0 && <li className="py-2 text-[#9A8A7E]">No events.</li>}
        {rows.map((r) => (
          <li key={r.id} data-testid="consent-row" className="py-2">
            <div className="flex justify-between gap-2">
              <span><span className="px-2 py-0.5 rounded-full bg-[#F4E4DA] text-[#7B2C3B] mr-1.5">{r.action.replace('_', ' ')}</span><span className="font-mono">{r.phone || '—'}</span></span>
              <span className="text-[#9A8A7E] whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</span>
            </div>
            <p className="text-[#9A8A7E] mt-0.5">{r.source}{r.consent_version ? ` · wording v${r.consent_version}` : ''}{r.ip ? ` · ${r.ip}` : ''}</p>
            {r.guest_id && <ConsentProofButton testId={`admin-guest-consent-pdf-${r.id}`} path={`/admin/compliance/consent-proof/guest/${r.guest_id}.pdf`} filename={`consent-${r.guest_id.slice(0, 8)}.pdf`} label="Guest consent PDF" toast={toast} />}
          </li>
        ))}
      </ul>
    </section>
  );
}
